import { RatePlanDetailsProps } from "@/components/Inputs/RatesPicker/components/RatePlanDetailsProps.ts";
import { customRenderingPPNOrganizations } from "@/helpers/customFeatures.ts";
import { formatCurrency } from "@/helpers/formatCurrency.ts";
import { formatDiscount } from "@/helpers/formatDiscount.ts";
import { RateSellMode } from "@/helpers/types/types.ts";
import { useGetOrganization } from "@/helpers/useGetOrganization.ts";
import { useEngineStore } from "@/stores/EngineStore/EngineStore.ts";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

export const ClassicRatePlanDetails = (props: RatePlanDetailsProps) => {
  const { t } = useTranslation();
  const { organizationName } = useGetOrganization();
  const defaultAdults = useEngineStore((state) => state.defaultAdults);

  const showDiscount = useMemo(() => {
    return props.ratePlan.defaultPriceBreakdown.discountPercentage > 0;
  }, [props.ratePlan.defaultPriceBreakdown?.discountPercentage]);

  const RP = useMemo(() => {
    return props.ratePlan.rateSellMode !== RateSellMode.PerPerson
      ? props.ratePlan
      : props.ratePlan.childRatePlans?.find((rp) => rp.occupancy === defaultAdults) || props.ratePlan;
  }, [props.ratePlan, defaultAdults]);

  if (!props.ratePlan.isAvailable) return null;

  return (
    <div className="c-rate__center u-h6 u-fw-600">
      {showDiscount && (
        <span className="c-rate__center--discount">
          {t("saveWithDiscount")} {formatDiscount(RP.defaultPriceBreakdown.discountPercentage)}
        </span>
      )}

      {showDiscount ? (
        <div className="c-rate__center-price">
          <span className="c-rate__center--discount-original-price">
            {formatCurrency(RP.lowestPrice / (1 - RP.defaultPriceBreakdown.discountPercentage / 100))}
          </span>
          {formatCurrency(RP.lowestPrice)}
        </div>
      ) : (
        <>
          <span className="c-rate__from">{t("from")} </span>
          {formatCurrency(RP.lowestPrice)}
        </>
      )}

      {/* Custom (no)rendering */}
      {customRenderingPPNOrganizations.includes(organizationName || "") || (
        <>
          <div className="c-rate__info u-p1">
            2 {t("persons")}, {t("perNight")}
          </div>
        </>
      )}
    </div>
  );
};
